import SVGIconBase from './SVGIconBase';
import { jsx as _jsx } from "react/jsx-runtime";
const UpgradeIcon = props => /*#__PURE__*/_jsx(SVGIconBase, Object.assign({}, props, {
  children: /*#__PURE__*/_jsx("path", {
    d: "m23.56,16.08c-.2.18-.45.28-.7.28s-.52-.1-.72-.31l-6.14-6.35-6.14,6.35c-.19.21-.45.31-.71.31s-.51-.1-.7-.28c-.4-.39-.41-1.02-.02-1.42l6.8-7.03c.21-.22.49-.32.77-.3.29-.02.57.08.78.3l6.8,7.03c.38.4.37,1.03-.02,1.42Zm-6.5,7.52v-10.04c0-.55-.45-1-1-1s-1,.45-1,1v10.04c0,.55.45,1,1,1s1-.45,1-1Zm-1.06-19.6c-6.62,0-12,5.38-12,12s5.38,12,12,12,12-5.38,12-12-5.38-12-12-12m0-2c7.73,0,14,6.27,14,14s-6.27,14-14,14S2,23.73,2,16,8.27,2,16,2h0Z"
  })
}));
export default UpgradeIcon;